import { Component } from "@angular/core";
import { ConfigService, Filters, OneOf } from "../../../common";
import { ItemsFiltersModel } from "./items-filters.model";

@Component({
  selector: "items-filters",
  templateUrl: "./items-filters.html",
  standalone: false,
})
export class ItemsFilters implements Filters {
  model: ItemsFiltersModel;
  wasteTypeOptions: string[];
  sortOptions: string[];

  constructor(private configService: ConfigService) {
    this.model = new ItemsFiltersModel();

    this.configService.get().subscribe((config) => {
      this.wasteTypeOptions = config.wasteTypeOptions;
      this.sortOptions = config.itemSortingOptions;
    });
  }

  public get state(): string {
    return this.model.getState();
  }

  public set state(value: string) {
    this.model = new ItemsFiltersModel(value);

    this.model.type = OneOf(this.model.type, this.wasteTypeOptions);
    this.model.sortBy = OneOf(this.model.sortBy, this.sortOptions);
  }

  reset() {
    this.model = new ItemsFiltersModel();
  }
}
